const initialState = {
    showing: false,
    optional: false,
    acceptedTermsVersion: null,
    isError: false,
    errorMessage: null,
}

export default function api(state = initialState, action) {
    switch (action.type) {
        case "SHOW_OPTIONAL_TERMS_OF_USE":
            return {
                ...state,
                showing: true,
                optional: true,
            }
        case "SHOW_TERMS_OF_USE":
            return {
                ...state,
                showing: true,
                optional: false,
            }
        case "HIDE_TERMS_OF_USE":
            return {
                ...state,
                showing: false,
            }
        case "SET_ACCEPTED_TERMS_OF_USE_VERSION":
            return {
                ...state,
                acceptedTermsVersion: action.version,
                error: false,
                errorMessage: null,
            }
        case "SET_ERROR":
            return {
                ...state,
                error: true,
                errorMessage: action.errorMessage,
            }
        default:
            return state;
    }
}
